<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'
import ChatCards from '@/domains/investor/components/ChatCards/ChatCards.vue'

definePageMeta({
  layout: 'investor',
})

const { t } = useI18n()
const filesSectionId = t('investor.dataPresentations.investorChats.filesSectionId')
</script>

<template>
  <div>
    <InvestorHero
      image="/images/investor/hero/investor-chats.png"
      :title="$t('investor.dataPresentations.investorChats.hero.title')"
      :lead="$t('investor.dataPresentations.investorChats.hero.lead')"
      :first-button="{
        text: $t('investor.dataPresentations.investorChats.hero.firstButton'),
        to: `#${filesSectionId}`,
      }"
    />

    <UiSection :id="filesSectionId">
      <FileList
        request-id="czaty-inwestorskie"
        :show-title="true"
        :file-item-options="{
          showDate: true,
        }"
      />
    </UiSection>
  </div>
</template>
